import { render, staticRenderFns } from "./PersonalizeSMS.vue?vue&type=template&id=67fd40f1&scoped=true"
import script from "./PersonalizeSMS.vue?vue&type=script&lang=ts"
export * from "./PersonalizeSMS.vue?vue&type=script&lang=ts"
import style0 from "./PersonalizeSMS.vue?vue&type=style&index=0&id=67fd40f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fd40f1",
  null
  
)

export default component.exports